// Write your code here
import {AiFillCalendar} from 'react-icons/ai'

const ProjectTimelineCard = props => {
  const {projectTitle, description, imageUrl, duration, projectUrl} = props
  return (
    <div>
      <img
        src={imageUrl}
        alt="project"
        className={`
      w-[100%]
      `}
      />
      <div>
        <h1>{projectTitle}</h1>
        <div>
          <AiFillCalendar />
          <p>{duration}</p>
        </div>
      </div>
      <p>{description}</p>
      <a rel="noreferrer noopener" href={projectUrl} target="_blank">
        Visit
      </a>
    </div>
  )
}

export default ProjectTimelineCard
